export default __webpack_public_path__ + "static/media/react.903d77ad.svg";